export const TOGGLE_TASK_STATUS = "TOGGLE_TASK_STATUS"
export const UPDATE_USER_TASK = "UPDATE_USER_TASK"
export const UNMOUNT_TASK = "UNMOUNT_TASK"

export const updateUserTask = (task) => ({
  type: UPDATE_USER_TASK,
  task,
})

export const unmountTask = () => ({
  type: UNMOUNT_TASK,
})

export const toggleTaskStatus = (params, success, error) => ({
  type: TOGGLE_TASK_STATUS,
  params,
  success,
  error,
})
